export const firstSymbolsToUppercase = (text: string) => {
  return text
    .split(" ")
    .map((word) =>
      word
        .split("")
        .map((symbol, idx) => (idx == 0 ? symbol.toUpperCase() : symbol))
        .join(""),
    )
    .join(" ");
};
